/* manage different color logo on collection page having banner image */
  $('x-header').mouseenter(function () {
          if($(this).hasClass('collection_banner') && !$(this).hasClass('is-solid')){
                     console.log('white now');
                  if ($('a.header__logo').is('.transparent_logo'))
                  {
                      $('a.header__logo').removeClass('transparent_logo')
                  }
                  $('a.header__logo').html('<img src=https://cdn.shopify.com/s/files/1/0266/1774/1359/files/GDV_Logo_Horse_Above_2.png?v=1717710488" alt="" srcset="//www.graysondevere.com/cdn/shop/files/GDV_Logo_Horse_Above_2.png?v=1717710488&amp;width=520 520w, //www.graysondevere.com/cdn/shop/files/GDV_Logo_Horse_Above_2.png?v=1717710488&amp;width=780 780w" width="2000" height="1000" sizes="260px" class="header__logo-image">');
            }
          });
          $('x-header').mouseleave(function () {
            if($(this).hasClass('collection_banner') && !$(this).hasClass('is-solid')){
               console.log('grey logo');
                  if ($('a.header__logo').is('.transparent_logo')){}
                  else{
                      $('a.header__logo').addClass('transparent_logo')
                  }
                  $('a.header__logo').html('<img src="https://cdn.shopify.com/s/files/1/0266/1774/1359/files/GDV_Logo_Horse_Above_White_2.png?v=1717710491" alt="" srcset="//www.graysondevere.com/cdn/shop/files/GDV_Logo_Horse_Above_White_2.png?v=1717710491&amp;width=520 520w, //www.graysondevere.com/cdn/shop/files/GDV_Logo_Horse_Above_White_2.png?v=1717710491&amp;width=780 780w" width="2000" height="1000" sizes="260px" class="header__logo-image">');
            }
          });
/* //manage different color logo on collection page having banner image */

/*
  make the entirety of the slideshow clickable
*/
$('.slideshow__slide.is-selected').click(function(){
    var link = $(this).parent().find('a.link').attr('href');
    if(link != '' && link != 'undefined'){
    window.location.href = link;
    }
});


/*
 * Sticky header
*/
$(window).scroll(function(){
  var sticky = $('header'),
      scroll = $(window).scrollTop();
  if (scroll > 50) {
    console.log('add');
    sticky.addClass('sticky_header');
  }
  else{
    console.log('remove');
  sticky.removeClass('sticky_header');
  }
});


/* Portfolio detail page gallery */
  /* wrap each 3 href tags in a div */
    var divs = $("div.collection-list > a.port_image");
    for(var i = 0; i < divs.length; i+=3) {
      divs.slice(i, i+3).wrapAll("<div class='wrap_port'></div>");
    }
  /* //wrap each 3 href tags in a div */

/* onclick href open large image */
$('.port_image').click(function(e){
    e.preventDefault();
  
  $('.port_full_img').empty();
  $('.port_full_img').remove();
  var getImage = $(this).find('img.pr_img').attr('src');
  
      var newDiv = '<div class="port_full_img"><span class="close" title="Close"><svg role="img" width="35" height="35" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="needsclick  kl-private-reset-css-Xuajs1"><title id="title-Close-dialog">Close dialog</title><circle cx="10" cy="10" r="9.5" fill="rgba(255,255,255,0)" stroke="rgba(255,255,255,0)" style="cursor: pointer;"></circle><path d="M6 6L14 14M6 14L14 6L6 14Z" stroke="rgba(43,44,46,1)" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round" style="cursor: pointer;"></path></svg></span><img src="'+getImage+'"></div>';
      $(this).parent('div.wrap_port').before(newDiv);

    setTimeout(
  function() 
  {
    scrollToImage();//do something special
  }, 1500);
});
/* //onclick href open large image */

function scrollToImage(){
      $('html, body').animate({
        scrollTop: $('div.port_full_img').offset().top - 120
      }, 'slow'); // The 'slow' argument controls the animation speed
}

/* onclick close large image */
$(document).on('click', '.close', function() {
  $('.port_full_img').remove();
});
/* //onclick close large image */
/* //Portfolio detail page gallery */